/* eslint-disable import/first */
import * as metricFormatter from '@bingads-webui-campaign-legacy/performance-metric-formatter/index';
import dateUtil from '@bingads-webui-component-legacy/humanize/date';
import jsdata from '@bingads-webui-component-legacy/js-data-campaign/index';
import cacheManager from '@bingads-webui-campaign-legacy/cache-manager/index';
// eslint-disable-next-line
import _bingads_webui_component_legacy_legacy_router_index from '@bingads-webui-component-legacy/legacy-router/index';
// eslint-disable-next-line
const { legacyRouter } = _bingads_webui_component_legacy_legacy_router_index;
import pageContext from '@bingads-webui-static-legacy/page-context';
import instrumentation from '@bingads-webui-static-legacy/instrumentation/index';
import constants from '@bingads-webui-static-legacy/instrumentation/constants';

const s$i18n = window.globalLegacyI18n.get('$/schema-i18n!campaign');
const legacyI18n = window.globalLegacyI18n.get('@bingads-webui/i18n-amd-loader!campaignui/feature/dashboard-cards');

const deps = {
  legacyRouter,
  pageContext,
  instrumentation,
  constants,
  metricFormatter,
  i18n: legacyI18n,
  s$i18n,
};

export const conversionTrackingDeps = {
  dateUtil,
  jsdata,
  cacheManager,
  s$i18n,
  legacyI18n,
  deps,
};

